import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home     from "./pages/Home";
import AboutUs  from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import News     from "./pages/News";
import Services from "./pages/Services";
import Careers  from "./pages/Careers";
import Login    from "./pages/Login";
import Start    from "./pages/Start";
import NotFound from "./pages/NotFound";
import SimpleAdmin from './pages/SimpleAdmin';
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";



function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/"           element={<Home />} />
        <Route path="/about"      element={<AboutUs />} />
        <Route path="/about-us"   element={<Navigate to="/about" replace />} />
        <Route path="/contact"    element={<ContactUs />} />
        <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
        <Route path="/news"       element={<News />} />
        <Route path="/services"   element={<Services />} />
        <Route path="/careers"    element={<Careers />} />
        <Route path="/login"      element={<Login />} />
        <Route path="/start"      element={<Start />} />
        <Route path="/hr-view" element={<SimpleAdmin />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="*"           element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
